export const constructAmlProjectUrl = (amlProjectPath: string) => {
    const splittedPath = amlProjectPath?.split('/');
    const projectId = splittedPath?.[splittedPath?.indexOf('projects') + 1];
    const route = amlProjectPath?.substring(0, amlProjectPath?.indexOf('/projects'));
    const url = `https://ml.azure.com/labeling/project/${projectId}/details?wsid=${route}`;
    return url;
};
